module.exports = __webpack_public_path__ + "img/9788954425100.11e540bd.jpg";